import { FunctionComponent, ReactNode } from 'react';
import {
  Icon,
  ICON_TYPES,
  IconType,
  NotificationVariant,
  StyledNotificationBox,
} from './NotificationBox.styles';

export interface NotificationBoxProps {
  variant: NotificationVariant;
  icon?: IconType;
  children: ReactNode;
  className?: string;
}

const NotificationBox: FunctionComponent<NotificationBoxProps> = ({
  variant,
  icon,
  children,
  className,
}) => {
  const defaultIcon =
    variant === 'success' ? ICON_TYPES.SUCCESS : ICON_TYPES.INFO;

  return (
    <StyledNotificationBox variant={variant} className={className}>
      <Icon type={icon || defaultIcon} />
      {children}
    </StyledNotificationBox>
  );
};

export default NotificationBox;
